module.exports = __webpack_public_path__ + "static/media/W09F2160-WEB5.05b6893f.svg";